var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-content" },
    [
      _c("management-tabs-and-search", {
        attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
        on: {
          "update-open-tab": function($event) {
            _vm.openTab = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        { attrs: { value: _vm.openTab } },
        [
          _c("v-tab-item", { attrs: { value: "Workorder" } }, [
            _vm._v("\n      work\n    ")
          ]),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "activities" } },
            [
              _c("activities-table", {
                on: {
                  openActivity: function($event) {
                    return _vm.ActivityUuid($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "details" } },
            [
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _c(_vm.activePage.activityDetails, {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activityIsActive,
                        expression: "activityIsActive"
                      }
                    ],
                    tag: "component",
                    attrs: { activityUUID: _vm.activityUUID },
                    on: { viewTask: _vm.viewTask }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _vm.taskIsActive
                    ? _c(_vm.activePage.taskDetails, {
                        tag: "component",
                        attrs: { task: _vm.task, backButton: _vm.backButton }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66637f3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66637f3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Activities/ActivitiesTab.vue
// module id = null
// module chunks = 